import * as React from "react";
import * as PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Metrics } from "../../vars";
import { KEY_TAB } from "./dropdown.consts";

class DropdownMenu extends React.Component<any, any> {
  static propTypes = {
    center: PropTypes.bool,
    onCloseButtonClick: PropTypes.func,
    open: PropTypes.bool,
    pullRight: PropTypes.bool,
    width: PropTypes.number,
  };

  static defaultProps = {
    onCloseButtonClick: () => {},
  };

  addInteractionHandlersToCloseButton = (Component) =>
    React.cloneElement(Component, {
      onClick: this.props.onCloseButtonClick,
      onKeyDown: this.handleCloseButtonKeyDown,
    });

  handleCloseButtonKeyDown = (e) => {
    switch (e.keyCode) {
      case KEY_TAB:
        this.props.onCloseButtonClick();
        break;
      default:
    }
  };

  render() {
    const { children, className } = this.props;

    const enhancedChildren = React.Children.map(children, (child: any) => {
      if (child && child.props && child.props.role === "closeDropdownButton") {
        return this.addInteractionHandlersToCloseButton(child);
      }

      return child;
    });

    return <div className={className}>{enhancedChildren}</div>;
  }
}

export default styled(DropdownMenu)`
  position: absolute;
  display: ${(props) => (props.open ? "block" : "none")};
  width: ${(props) => (props.width ? `${props.width}px` : "100%")};
  max-width: ${(props) => (props.width ? `${props.width}px` : "100%")};
  top: 100%;
  z-index: ${Metrics.ZIndexes.HOVER_DROPDOWN_MENU};

  left: ${(props) => (props.pullRight ? "auto" : 0)};
  right: ${(props) => (props.pullRight ? 0 : "auto")};

  ${getPosition};
`;

function getPosition(props) {
  if (props.center && props.width) {
    return css`
      left: calc(50% - ${props.width / 2}px);
    `;
  }

  if (props.pullRight) {
    return css`
      left: auto;
      right: 0;
    `;
  }

  return css`
    left: 0;
    right: auto;
  `;
}
